$(document).ready(function () {
  var check = false;
  var ga_interval = setInterval(checkApp, 100);
  var productSelect = $('#ProductSelect option:selected').text().split("-");
  var currentDays = productSelect[0].trim().split(" ");
  function checkApp() {
    if ($(".ga-product_bought_together").length) {
      check = true;
      clearInterval(ga_interval);
    }
    if (check) {
      $('.ga-product_variant_select').each(function () {
        var currentSelect = $(this);
        currentSelect.find('option').each(function () {
          var optionDays = $(this).text().split(" ");
          if (optionDays[0] == currentDays[0]) {
            currentSelect.val($(this).attr('value'));
          }
        });
      });
      $(".ga-product .selectedItem").each(function (index, value) {
        var self = this;
        if ($(self).prop('checked') == false) {
          $(this).closest('li').find('.ga-product_variants-container .ga-product_variant_select').removeAttr('name');
        }
        $(self).on('change', function () {
          if ($(this).prop('checked') == true) {
            $(this).closest('li').find('.ga-product_variants-container .ga-product_variant_select').attr('name', 'id[]');
          }
          else {
            $(this).closest('li').find('.ga-product_variants-container .ga-product_variant_select').removeAttr('name');
          }
        });
      });
    }
  }
});
// Onchange Event
$(document).on('change', 'form[action*="/cart/add"]:visible:first input, form[action*="/checkout"]:visible:first input, form[action*="/cart/add"]:visible:first select:not(.ga-product_variant_select), form[action*="/checkout"]:visible:first select:not(.ga-product_variant_select)', function (e) {
  var currentDays = $(e.currentTarget).val().split(" ");
  $('.ga-product_variant_select').each(function () {
    var currentSelect = $(this);
    currentSelect.find('option').each(function () {
      var optionDays = $(this).text().split(" ");
      if (optionDays[0] == currentDays[0]) {
        currentSelect.val($(this).attr('value'));
      }
    });
  })
});